common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initAnimations();
    },

    initAnimations() {
        let sal = require('sal.js');
    
        sal({
            threshold: 0.1,
            once: true,
        });
    },
});
